// extracted by mini-css-extract-plugin
export default {"login":"Login_login__64brd","user-profile":"Login_user-profile__5Nc0d","user-box":"Login_user-box__8M6lh","btn-box":"Login_btn-box__T1occ","move-btn":"Login_move-btn__4pGwr"};